/**
 * @file Audit trail component
 * @author Heino Lenting
*/
import * as tslib_1 from "tslib";
import { DomainService } from '../../domain.service';
import { DataSet } from '../../core/helpers/data-set';
import { durationToText } from '../../core/helpers/durationToText';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DomSanitizer } from '@angular/platform-browser';
import { LocalisationService } from '../../core/localisation.service';
import { RepeatAdapter } from '../../domain/helpers/repeat-adapter';
var AuditTrailComponent = /** @class */ (function () {
    function AuditTrailComponent(domainService, translateService, sanitized, localisationService) {
        var _this = this;
        this.domainService = domainService;
        this.translateService = translateService;
        this.sanitized = sanitized;
        this.localisationService = localisationService;
        this.isRefreshing = true;
        /** Total nr of trailitems */
        this.totalItems = 0;
        /** Page size of the list */
        this.pageSize = 10;
        /** Number of items shown */
        this.nrItemsShown = 0;
        this.entityInfo = {
            'Assignment': {
                'icon': 'sym-icon-task',
                'label': 'APP.AUDIT_TRAIL.ASSIGNMENT'
            },
            'Assignment-Is-Appointment': {
                'icon': 'sym-icon-appointment',
                'label': 'APP.AUDIT_TRAIL.ASSIGNMENT-AS-APPOINTMENT'
            },
            'SpendTime': {
                'icon': 'sym-icon-realization',
                'label': 'APP.AUDIT_TRAIL.SPENDTIME'
            },
            'Attendant': {
                'icon': 'sym-icon-attendant',
                'label': 'APP.AUDIT_TRAIL.ATTENDANT'
            },
            'Appointment': {
                'icon': 'sym-icon-absence',
                'label': 'APP.AUDIT_TRAIL.APPOINTMENT'
            },
            'Availability': {
                'icon': 'sym-icon-availability',
                'label': 'APP.AUDIT_TRAIL.AVAILABILITY'
            },
            'Repeat': {
                'icon': 'sym-icon-repeat',
                'label': 'APP.AUDIT_TRAIL.REPEAT'
            },
            'TaskTemplate': {
                'icon': 'sym-icon-task',
                'label': 'APP.AUDIT_TRAIL.TASK_TEMPLATE'
            },
            'Service': {
                'icon': 'sym-icon-service',
                'label': 'APP.AUDIT_TRAIL.SERVICE'
            },
            'ServiceTemplate': {
                'icon': 'sym-icon-service',
                'label': 'APP.AUDIT_TRAIL.SERVICE_TEMPLATE'
            },
            'Shift': {
                'icon': 'sym-icon-shift',
                'label': 'APP.AUDIT_TRAIL.SHIFT'
            },
            'ShiftTemplate': {
                'icon': 'sym-icon-shift',
                'label': 'APP.AUDIT_TRAIL.SHIFT_TEMPLATE'
            },
            'Task': {
                'icon': 'sym-icon-task',
                'label': 'APP.AUDIT_TRAIL.TASK'
            },
            'Deployment': {
                'icon': 'sym-icon-reservation',
                'label': 'APP.AUDIT_TRAIL.DEPLOYMENT'
            },
            'Demand': {
                'icon': 'sym-icon-task',
                'label': 'APP.AUDIT_TRAIL.DEMAND'
            },
            'Project': {
                'icon': 'sym-icon-project',
                'label': 'APP.AUDIT_TRAIL.PROJECT'
            },
            'Taskneed': {
                'icon': 'sym-icon-requirement',
                'label': 'APP.AUDIT_TRAIL.TASKNEED'
            },
            'unknown': {
                'icon': 'sym-icon-unknown',
                'label': 'APP.AUDIT_TRAIL.UNKNOWN'
            }
        };
        this.transformers = {
            'default': function (value) {
                // Null is an object, thats why this check
                if (value == null) {
                    return '';
                }
                if (typeof value === 'string' || value === 'number') {
                    return value;
                }
                if (typeof value === 'object' && value !== null && value['Name']) {
                    return value['Name'];
                }
                if (typeof value === 'object' && value !== null && value['FirstName'] && value['Name']) {
                    return value['FirstName'] + ' ' + value['Prefix'] + ' ' + value['Name'];
                }
                return '';
            },
            'Completed': function (value) { return _this.translateService.instant('APP.AUDIT_TRAIL.VALUE.BOOLEAN.' + ((value === 100) ? 'TRUE' : 'FALSE')); },
            'Start': function (value) { return (value) ? moment(value).format(_this.localisationService.dateTime.format) : ''; },
            'Finish': function (value) { return (value) ? moment(value).format(_this.localisationService.dateTime.format) : ''; },
            'StartBase': function (value) { return (value) ? moment(value).format(_this.localisationService.dateTime.format) : ''; },
            'FinishBase': function (value) { return (value) ? moment(value).format(_this.localisationService.dateTime.format) : ''; },
            'Color': function (value) { return (value) ? _this.sanitized.bypassSecurityTrustHtml('<span style="padding-left: 3px; padding-right: 3px; border-radius: 3px; background-color: ' + value + '">' + value + '</span>') : ''; },
            'Effort': function (value) { return (value) ? durationToText(moment.duration(value)) : ''; },
            'TravelTime': function (value) { return (value) ? durationToText(moment.duration(value)) : ''; },
            'HoursOfLeave': function (value) { return (value) ? durationToText(moment.duration(value)) : ''; },
            'WorkUnit': function (value) { return (value) ? durationToText(moment.duration(value)) : ''; },
            'WorkStatus': function (value) { return (value) ? _this.translateService.instant('APP.AUDIT_TRAIL.VALUE.WORKSTATUS.' + value.toLocaleUpperCase()) : ''; },
            'Unforeseen': function (value) { return (value) ? _this.translateService.instant('APP.AUDIT_TRAIL.VALUE.UNFORESEEN.' + value.toLocaleUpperCase()) : ''; },
            'Purpose': function (value) { return (value) ? _this.translateService.instant('APP.AUDIT_TRAIL.VALUE.PURPOSE.' + value.toLocaleUpperCase()) : ''; },
            'Appointment': function (value) { return (value !== undefined) ? _this.translateService.instant('APP.AUDIT_TRAIL.VALUE.BOOLEAN.' + ((value === true) ? 'TRUE' : 'FALSE')) : ''; },
            'IsAbsence': function (value) { return (value !== undefined) ? _this.translateService.instant('APP.AUDIT_TRAIL.VALUE.BOOLEAN.' + ((value === true) ? 'TRUE' : 'FALSE')) : ''; },
            'Closed': function (value) { return (value !== undefined) ? _this.translateService.instant('APP.AUDIT_TRAIL.VALUE.BOOLEAN.' + ((value === true) ? 'TRUE' : 'FALSE')) : ''; },
            'EffortBudget': function (value) { return (value) ? durationToText(moment.duration(value)) : ''; },
            'HoursPerUnit': function (value) { return (value) ? durationToText(moment.duration(value)) : ''; },
            'Prognosed': function (value) { return (value) ? durationToText(moment.duration(value)) : ''; },
            'Planned': function (value) { return (value) ? durationToText(moment.duration(value)) : ''; },
            // 'Resource': (value) => (value && value['FirstName'] && value['Name']) ? value['FirstName'] + ' ' + value['Prefix'] + ' ' + value['Name'] : '',
            // 'Account': (value) => (value && value['FirstName'] && value['Name']) ? value['FirstName'] + ' ' + value['Prefix'] + ' ' + value['Name'] : '',
            // 'Manager': (value) => (value && value['FirstName'] && value['Name']) ? value['FirstName'] + ' ' + value['Prefix'] + ' ' + value['Name'] : '',
            // 'Department': (value) => (value && value['Name']) ? value['Name'] : '',
            // 'Concerns': (value) => (value && value['Name']) ? value['Name'] : '',
            // 'Deployment': (value) => (value && value['Name']) ? value['Name'] : '',
            // 'Service': (value) => (value && value['Name']) ? value['Name'] : '',
            // 'Customer': (value) => (value && value['Name']) ? value['Name'] : '',
            // 'Shift': (value) => (value && value['Name']) ? value['Name'] : '',
            'RepeatSummary': function (value, item) {
                if (!item) {
                    return '';
                }
                if (item.Start) {
                    item.Start = new Date(item.Start);
                }
                if (item.UntilDate) {
                    item.UntilDate = new Date(item.UntilDate);
                }
                if (item.Owner) {
                    if (item.Owner['Start']) {
                        item.Owner['Start'] = new Date(item.Owner['Start']);
                    }
                    if (item.Owner['UntilDate']) {
                        item.Owner['UntilDate'] = new Date(item.Owner['UntilDate']);
                    }
                }
                var repeatAdapter = new RepeatAdapter(function () {
                    return item;
                }, _this.translateService, _this.localisationService, _this.domainService);
                return repeatAdapter.summary();
            },
            'SumFactor': function (value) {
                if (!value) {
                    return '';
                }
                if (value === 1) {
                    return _this.translateService.instant('APP.MISC.PLANITEM.SUMFACTOR_ADD');
                }
                if (value === 0) {
                    return _this.translateService.instant('APP.MISC.PLANITEM.SUMFACTOR_NONE');
                }
                if (value === -1) {
                    return _this.translateService.instant('APP.MISC.PLANITEM.SUMFACTOR_SUBTRACT');
                }
            },
            'Weight': function (value) {
                if (!value) {
                    return '';
                }
                if (value === 1) {
                    return _this.translateService.instant('APP.MISC.AVAILABILITY.LOVE_TO');
                }
                if (value === 0) {
                    return _this.translateService.instant('APP.MISC.AVAILABILITY.I_CAN');
                }
                if (value === -1) {
                    return _this.translateService.instant('APP.MISC.AVAILABILITY.PREFER_NOT');
                }
            },
            'Draft': function (value) { return _this.translateService.instant('APP.AUDIT_TRAIL.VALUE.DRAFT.' + ((value === true) ? 'TRUE' : 'FALSE')); },
            'RateOfWork': function (value) { return (value !== undefined && value !== 0) ? _this.translateService.instant('APP.AUDIT_TRAIL.VALUE.RATEOFWORK.' + value) : ''; }
        };
        this.configuration = {
            instruction: 'instructions/standaard/core/social/audit-trail/audit-trail'
        };
        this._trail = null;
        this._trail = new DataSet(domainService);
        this._trail.sourceName = 'Trail';
        this._trail.queryOptions = {};
        this.nrItemsShown = this.pageSize;
    }
    AuditTrailComponent.prototype.trailFiltered = function () {
        return this._trail.items.filter(function (item) { return item['Action'] !== 'Invoke'; });
    };
    Object.defineProperty(AuditTrailComponent.prototype, "trail", {
        get: function () {
            if (this._trail == null) {
                return [];
            }
            // return this._trail.items;
            return this.trailFiltered().slice(0, this.nrItemsShown);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuditTrailComponent.prototype, "entityKey", {
        /**
        * Get the entity key
        */
        get: function () {
            return this.entityKeyValue;
        },
        set: function (value) {
            if (this.entityKeyValue === value) {
                return;
            }
            this.entityKeyValue = value.split('_')[0];
            this.refresh();
        },
        enumerable: true,
        configurable: true
    });
    /**
    * Get the user Oid
    */
    AuditTrailComponent.prototype.userOid = function (id) {
        return DomainService.oidWith(126, id);
    };
    AuditTrailComponent.prototype.refresh = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isRefreshing = true;
                        if (this.entityKeyValue == null || this.entityKeyValue.indexOf('K_-') === 0) {
                            return [2 /*return*/];
                        }
                        this._trail.queryOptions.parameters = {};
                        this._trail.queryOptions.parameters.entityType = DomainService.oidToClassName(this.entityKeyValue);
                        this._trail.queryOptions.parameters.entityId = this.entityKeyValue;
                        // Hoe diep wil je gaan? Wil je ook de SpendTime bij een Shift van bijvoorbeeld Shift.Servive.Attendant
                        // Zouden we eerst hier hard coded kunnen bepalen aan de hand van de this._trail.queryOptions.parameters.entityType
                        this._trail.queryOptions.parameters.deep = 3;
                        // Met een hoge deep haal je mischien OOK de trail op van objecten waar je NIET in bent geintreseerd
                        // Dan heb je hier een spatie gescheiden lijst met entityType.shortName's van objecten die je uit je deep trail wil halen.
                        this._trail.queryOptions.parameters.exclude = 'Repeat';
                        // Voor later om de qualiatieve informatie detail van je trail te bepaalde.
                        this._trail.queryOptions.parameters.level = 0;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._trail.refresh()];
                    case 2:
                        _a.sent();
                        this.isRefreshing = false;
                        this.totalItems = this.trailFiltered().length;
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        this.isRefreshing = false;
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
    * Check if given detail is open
    */
    AuditTrailComponent.prototype.isDetailOpen = function (item) {
        if (!item.Id) {
            return false;
        }
        return (this.openDetailId === item.Id);
    };
    /**
    * Toggle the detail open
    */
    AuditTrailComponent.prototype.toggleDetailOpen = function (item) {
        if (!item.Id) {
            return false;
        }
        if (!this.openDetailId) {
            return this.openDetailId = item.Id;
        }
        if (this.openDetailId === item.Id) {
            this.openDetailId = undefined;
        }
        else {
            this.openDetailId = item.Id;
        }
    };
    /**
    * Translate the value into a human readable format
    */
    AuditTrailComponent.prototype.transform = function (property, value, item) {
        // if (!value) {
        //     throw new Error('Value is null');
        // }
        if (this.transformers[property]) {
            return this.transformers[property](value, item);
        }
        return this.transformers['default'](value, item);
    };
    /**
    * Get the correct icon
    */
    AuditTrailComponent.prototype.getIcon = function (type, tag) {
        if (tag && tag === 'IsAppointment') {
            type = 'Assignment-Is-Appointment';
        }
        if (type !== undefined && this.entityInfo[type]) {
            return this.entityInfo[type].icon;
        }
        return this.entityInfo['unknown'].icon;
    };
    /**
    * Translate to the correct label
    */
    AuditTrailComponent.prototype.getLabel = function (type, tag, action) {
        if (tag && tag === 'IsAppointment') {
            type = 'Assignment-Is-Appointment';
        }
        if (this.entityInfo[type]) {
            return this.entityInfo[type].label + '.' + action.toUpperCase();
        }
        return this.entityInfo['unknown'].label + '.' + action.toUpperCase();
    };
    /**
    * Translate to the correct label
    */
    AuditTrailComponent.prototype.getPropertyKey = function (property) {
        return 'APP.AUDIT_TRAIL.PROPERTY.' + property.toUpperCase();
    };
    /**
     * Collect the safe properties from current and, optional, previous
     */
    AuditTrailComponent.prototype.getProperties = function (entityType, current, previous) {
        if (previous === void 0) { previous = {}; }
        if (!current) {
            return [];
        }
        var currentProperties = this.removeIgnoredProperties(entityType, Object.keys(current));
        var previousProperties = this.removeIgnoredProperties(entityType, Object.keys(previous));
        // Concat current and previous properties and exclude duplicates
        var safeProperties = currentProperties.concat(previousProperties.filter(function (property) { return !currentProperties.includes(property); }));
        safeProperties = safeProperties.filter(function (property) {
            var hasValueInCurrent = current[property] !== undefined && current[property];
            var hasValueInPrevious = previous[property] !== undefined;
            return (hasValueInCurrent || hasValueInPrevious);
        });
        if (entityType === 'Repeat') {
            safeProperties.push('RepeatSummary'); // always add this one to 'enforce' showing the summary (see transformer 'UntilDate')
        }
        return safeProperties;
    };
    /**
    * Clean up the properties and return only the allowed properties
    */
    AuditTrailComponent.prototype.removeIgnoredProperties = function (entityType, properties) {
        return properties.filter(function (property) {
            if (property.endsWith('Oid')) {
                return false;
            }
            if (property.startsWith('_')) {
                return false;
            }
            if (property.endsWith('IsAbsence')) {
                return false;
            }
            if ((entityType === 'Assignment' || entityType === 'SpendTime') && (property === 'Unforeseen')) {
                return false;
            }
            if (entityType === 'Assignment' && property === 'HoursOfLeave') {
                return false;
            }
            if (entityType === 'Repeat' && ['Cycles', 'Days', 'Factor', 'Kind', 'Order', 'Start', 'UntilDate'].includes(property)) {
                return false;
            }
            if (property === 'RepeatPattern') {
                return false;
            }
            if (property === 'Account') {
                return false;
            }
            if (property === 'Owner') {
                return false;
            }
            return true;
        });
    };
    /**
    * Check if item has an user
    */
    AuditTrailComponent.prototype.hasUser = function (item) {
        return (item.UserId);
    };
    /**
    * Method to check if the name exists
    */
    AuditTrailComponent.prototype.hasName = function (item) {
        return (item['FirstName'] || item['LastName']);
    };
    /** Checks if there are more items available */
    AuditTrailComponent.prototype.hasMore = function () {
        return this.nrItemsShown < this._trail.items.length;
    };
    /** Show also the next page */
    AuditTrailComponent.prototype.showMore = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var nrToShow;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.refresh()];
                    case 1:
                        _a.sent();
                        if (this.hasMore()) {
                            nrToShow = this.nrItemsShown + this.pageSize;
                            if (nrToShow > this._trail.items.length) {
                                nrToShow = this._trail.items.length;
                            }
                            this.nrItemsShown = nrToShow;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return AuditTrailComponent;
}());
export { AuditTrailComponent };
